<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalLosses",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label: "19. (a) Have you ever sustained a loss or losses?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0LossSustainedId",
					props: {
						suggest: {
							typeIncludes: "lossSustained"
						},
						createOptions: {
							type: "lossSustained",
							dataType: "string"
						}
					}
				},
				{
					label:
						"19. (b) If so, give statement covering the past five years with particulars, including the amount of each loss, and, if insured, whether paid in full or otherwise.",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0LossDetailsId",
					props: {
						suggest: {
							typeIncludes: "lossDetails"
						},
						createOptions: {
							type: "lossDetails",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
